/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalChangeLog.vue?vue&type=template&id=f679a34e&scoped=true"
import script from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
export * from "./ModalChangeLog.ts?vue&type=script&lang=ts&external"
import style0 from "./ModalChangeLog.vue?vue&type=style&index=0&id=f679a34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f679a34e",
  null
  
)

export default component.exports